import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import CookiePrivacyPolicyPopup from "@insite/content-library/Components/CookiePrivacyPolicyPopup";
import Page from "@insite/mobius/Page";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface FooterStyles {
    container?: InjectableCss;
    footerPage?: InjectableCss;
    bottomFooterWrapper?: InjectableCss;
    bottomFooterZoneWrapper?: InjectableCss;
    preFooter?: InjectableCss;
    postFooter?: InjectableCss;
}

const styles: FooterStyles = {
    container: {
        css: css`
            background-color: #000000;
        `,
    },
    footerPage: {
        css: css`
            background-color: #000000;
        `,
    },
    bottomFooterWrapper: {
        css: css`
            background-color: #000000;
            width: 100%;
        `,
    },
    bottomFooterZoneWrapper: {
        css: css`
            max-width: 1700px;
            margin: auto;
            padding: 15px;
        `,
    },
    preFooter: {
        css: css`
            background-color: ${getColor("primary.main")};
            height: 10px;
        `,
    },
    postFooter: {
        css: css`
            background-color: #868686;
            height: 2px;
        `,
    },
};

const Footer: React.FunctionComponent<PageProps> = ({ id }: PageProps) => (
    <StyledWrapper {...styles.container}>
        <StyledWrapper {...styles.preFooter} />
        <Zone contentId={id} zoneName="TopFullWidthFooter" />
        <Page as="footer" isFooter={true} style={{ paddingTop: 25 }} {...styles.footerPage}>
            <Zone contentId={id} zoneName="Content" />
            <CookiePrivacyPolicyPopup />
        </Page>
        <StyledWrapper {...styles.postFooter} />
        <StyledWrapper {...styles.bottomFooterWrapper}>
            <StyledWrapper {...styles.bottomFooterZoneWrapper}>
                <Zone contentId={id} zoneName="BottomFullWidthFooter" />
            </StyledWrapper>
        </StyledWrapper>
    </StyledWrapper>
);

const pageModule: PageModule = {
    component: Footer,
    definition: {
        hasEditableTitle: false,
        hasEditableUrlSegment: false,
        pageType: "System",
    },
};

export default pageModule;
